import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import CommentPanel from '../../generic/CommentPanel';
import List from '../../generic/List';
import type { Scope } from '../../../../shared/issuesV2';
import type { IssueScanScope } from '../../../../typings/api';

//  The CommentsPanel is tied to v1, specifically in the
//  ScanScope and issueCategory it expects. This will go
//  away as part of: https://fossa.atlassian.net/browse/CORE-2316
const getV1ScanScope = (scope: Scope): IssueScanScope => {
  if (scope.type === 'project') {
    return {
      type: 'project',
      projectId: scope.id,
      revisionId: scope.revision,
      revisionScanId: scope.revisionScanId,
    } as IssueScanScope;
  }
  if (scope.type === 'releaseGroup') {
    // groupId: number; releaseId: number; scanId
    return {
      type: 'releaseGroup',
      groupId: scope.id,
      releaseId: scope.release,
      scanId: scope.releaseScanId,
    } as IssueScanScope;
  }
  // scope.type === 'global', or fallback
  return scope as IssueScanScope;
};

/**
 * IssueDetailsComments displays the comments for a given issue.
 */
const IssueDetailsComments: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const commentsProjectId = useSelector(IssuesV2Store.selectors.getIssueCommentsProjectId);

  return (
    <List>
      <List.Header>
        <List.HeaderText>
          Comments
        </List.HeaderText>
      </List.Header>
      <List.Body>
        <div className="padding-md width-full">
          <CommentPanel
            projectId={commentsProjectId}
            //  Hacky for now
            scanScope={getV1ScanScope(scope)}
            issueCategory={category}
          />
        </div>
      </List.Body>
    </List>
  );
};

export default IssueDetailsComments;
